/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: inherit
 */
import React, { useMemo, useState } from 'react';
import { MasterFilterSheetModal } from '../../shared/filters/MasterFilterSheetModal';
import { ModalFilterSelectTrigger } from '../../shared/modals/ModalFilterSelectTrigger';

type SupplierOption = { id: string; name: string };

type Props = {
  suppliers: SupplierOption[];
  supplierId: string | null;
  onSupplierIdChange: (id: string | null) => void;
  label?: string;
  submitting?: boolean;
};

export function ExpenseSupplierField({
  suppliers,
  supplierId,
  onSupplierIdChange,
  label = 'Proveedor',
  submitting = false,
}: Props) {
  const [sheetOpen, setSheetOpen] = useState(false);

  const valueLabel = useMemo(() => {
    if (!supplierId) return 'Ninguno';
    return suppliers.find((s) => s.id === supplierId)?.name ?? 'Proveedor';
  }, [supplierId, suppliers]);

  const options = useMemo(
    () => suppliers.map((s) => ({ id: s.id, name: s.name })),
    [suppliers]
  );

  return (
    <>
      <ModalFilterSelectTrigger
        label={label}
        value={valueLabel}
        active={supplierId != null}
        disabled={submitting}
        onPress={() => setSheetOpen(true)}
        accessibilityLabel={`${label}, ${valueLabel}`}
      />
      <MasterFilterSheetModal
        visible={sheetOpen}
        title="Proveedor"
        options={options}
        selectedId={supplierId}
        allOptionLabel="Ninguno"
        onSelect={onSupplierIdChange}
        onClose={() => setSheetOpen(false)}
      />
    </>
  );
}
